module.exports = __webpack_public_path__ + "img/Einkauf.5eec976c.svg";